import { NumberBadge } from './number-badge';
import { Button } from '@/components/ui/button';
import { SectionHeaderProps } from '@/lib/types';

export function SectionHeader({ title, badgeProps, buttonProps, isSubSection = true }: SectionHeaderProps) {
  return (
    <div className={`flex items-center justify-between min-h-[40px] my-[24px] ${!isSubSection && 'py-[16px]'}`}>
      <div className='flex items-center gap-2'>
        <p className={`${isSubSection ? 'text-[16px]' : 'text-[20px] leading-[28px'} font-bold`}>{title}</p>
        {badgeProps && 'number' in badgeProps && <NumberBadge number={badgeProps.number} />}
      </div>
      {buttonProps && (
        <div className='flex gap-2'>
          {buttonProps.map((button, index) => (
            <Button
              key={index}
              variant={button.variant || 'ghost'}
              className={button.className}
              onClick={button.onClick}
              disabled={button.disabled}
            >
              {button.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
